if(!customElements.get('column-slider')) {
  customElements.define(
    'column-slider',
    class ColumnSlider extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) {
          return console.error('An error ocurred initializing column slider. No slider element was found.');
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          autoplay: {
            disableOnInteraction: false,
            delay: 7000
          },
          pagination: {
            el: '.column-slider-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }
    }
  );
}
